<script setup>
import { ref } from 'vue';
import DeskCollapse from './DeskCollapse.vue';

const props = defineProps({
    articles: { type: Array, default: () => [] },
    labels: { type: Object, default: () => ({}) },
});

const expanded = ref(false);

const noteUrl = (article) => article.url || article.show_url || article.href || null;
</script>

<template>
    <section
        class="ticket-desk-panel ticket-desk-kb"
        :class="{ 'ticket-desk-panel--collapsed': !expanded }"
        data-testid="ticket-desk-operational-notes"
    >
        <button
            type="button"
            class="ticket-desk-panel-heading ticket-desk-panel-heading--toggle"
            :aria-expanded="expanded"
            @click="expanded = !expanded"
        >
            <h3>
                <span aria-hidden="true">✉</span>
                {{ labels.operationalNotes || labels.operational_notes || labels.ticket_notes || 'Note' }}
            </h3>
            <span class="ticket-desk-panel-heading__side">
                <span class="ticket-desk-badge ticket-desk-badge--neutral">{{ articles.length }}</span>
                <span class="ticket-desk-chevron" aria-hidden="true">▾</span>
            </span>
        </button>
        <DeskCollapse :expanded="expanded">
            <div class="ticket-desk-kb__body">
                <ul v-if="articles.length">
                    <li v-for="article in articles" :key="article.id || article.url || article.title">
                        <a
                            v-if="noteUrl(article)"
                            :href="noteUrl(article)"
                            class="ticket-desk-kb__link"
                        >
                            {{ article.title || article.label }}
                        </a>
                        <span v-else>{{ article.title || article.label }}</span>
                        <p v-if="article.body" class="ticket-desk-kb__excerpt">{{ article.body }}</p>
                    </li>
                </ul>
                <p v-else class="ticket-desk-empty">{{ labels.noOperationalNotes || 'Nessuna nota presente' }}</p>
            </div>
        </DeskCollapse>
    </section>
</template>

<style scoped>
.ticket-desk-kb__excerpt {
    margin: 4px 0 0;
    color: var(--ticket-desk-muted);
    font-size: 10px;
    white-space: pre-wrap;
}
</style>
